<template lang="pug">
#modal-confirmar-remocao-evidencia
    el-dialog.modal-argentina-remocao-evidencia(
        :visible.sync='show',
        :before-close='closeDialog',
        :title='$t("mensagens.territorio.territorioAr.modalRemocaoEvidencia.titulo")',
        :close-on-click-modal='false'
    )
        .body
            h1.titulo {{ $t('mensagens.territorio.territorioAr.modalRemocaoEvidencia.textoInicial') }}
            h1.titulo {{ $t('mensagens.territorio.territorioAr.modalRemocaoEvidencia.textoFinal') }}
        .footer
            el-button(type='secondary', @click='closeDialog') {{ $t('mensagens.territorio.territorioAr.modalRemocaoEvidencia.cancelar') }}
            el-button(type='primary', @click='confirma') {{ $t('mensagens.territorio.territorioAr.modalRemocaoEvidencia.confirmar') }}
</template>

<script>
export default {
    components: {},
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close', 'confirma'],
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        confirma() {
            this.$emit('confirma');
        }
    }
};
</script>

<style lang="scss">
.modal-argentina-remocao-evidencia {
    .el-dialog {
        .el-dialog__body {
            padding: 0 !important;
            display: flex;
            flex-direction: column;
            .body {
                padding: 18px 20px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .titulo {
                    font-weight: 400;
                    font-family: Roboto;
                    color: #3b3b3b;
                    padding: 0;
                    font-size: 14px;
                    line-height: 1.5;
                }
                .warning-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;
                    i {
                        font-size: 32px;
                        color: #e6a23c;
                    }
                }
            }
            .footer {
                margin-top: 10px;
                border-top: 1px solid #e0e0e0;
                padding: 8px 15px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 10px;
            }
        }
    }
}
</style>
